import { ShiftWiseEmployees } from "../../Api/shiftWiseEmployees";
import {
    GET_SHIFTWISEEMPLOYEES_FAILURE,
    GET_SHIFTWISEEMPLOYEES_SUCCESS,
    GET_SHIFTWISEEMPLOYEES_REQUEST
} from "../../Constants";

function getShiftWiseEmployeesRequest() {
  return {
    type: GET_SHIFTWISEEMPLOYEES_REQUEST,
    isFetching: true
  };
}
function getShiftWiseEmployeesSuccess(data) {
  return {
    type: GET_SHIFTWISEEMPLOYEES_SUCCESS,
    isFetching: false,
    shiftViewList: data
  };
}
function getShiftWiseEmployeesfailure(data) {
  return {
    type: GET_SHIFTWISEEMPLOYEES_FAILURE,
    isFetching: false,
    data
  };
}

//Get Technician Working hours
export const getShiftWiseEmployees = payload => (dispatch, getState) => {
  dispatch(getShiftWiseEmployeesRequest());
  ShiftWiseEmployees.getShiftWiseEmployeesData(payload)
    .then(res => {
      dispatch(getShiftWiseEmployeesSuccess(res));
    })
    .catch(err => dispatch(getShiftWiseEmployeesfailure(err)));
};
